<mat-progress-spinner *ngIf="isLoading"
                      style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)"
                      diameter="100" mode="indeterminate" data-cy="format-label-loading-spinner"></mat-progress-spinner>
<div class='Formatted-Labels-items-main' data-cy="format-label-container">
  <mat-grid-list *ngIf="!isLoading" cols="6" rowHeight="100%" style="height:100%;" data-cy="format-label-grid">
    <mat-grid-tile colspan="2" data-cy="format-label-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="format-label-list-card">
        <span class="configuration-section-title" data-cy="format-label-list-title">Formatted Labels</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="format-label-list-content">
          <tdo-table #table isAutoSelectFirstItem="true"
                     (rowSelected)="onRowSelected($event)" [dataSource]="labelUsers" [isSearchable]="false" data-cy="format-label-users-table">
            <tdo-table-column displayName="User" propertyName="FullName" [rowTemplate]="FullName" data-cy="format-label-users-name-column">
              <ng-template #FullName let-row>
                <div data-cy="format-label-user-name-{{row.index}}">{{row.model.FullName}}</div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="!isLoading" colspan="4" data-cy="format-label-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="format-label-detail-card">
        <mat-card-content data-cy="format-label-detail-content">
          <div style="max-width: 100%;" data-cy="format-label-detail-container">
            <app-tdo-configuration-action-bar [showEdit]="false" [saveDisabled]="false" [showSave]="false"
                                              [showCancel]="false" [newHidden]="false" [showAdd]="false"
                                              (newClick)="onNewFormattedLabelTokens($event)"
                                              (saveClick)="saveFormattedLabels($event)" 
                                              data-cy="format-label-action-bar"></app-tdo-configuration-action-bar>
            <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="format-label-tokens-container">
              <div style="display: flex;" data-cy="format-label-format-selector">
                <div style="flex-basis: 150px; text-align: center; margin-right: 4px;margin-top: 10px; font-weight: 500;" data-cy="format-label-format-label">
                  Formatting For:
                </div>
                <div style="flex: 1; max-width: 300px" data-cy="format-label-format-dropdown-container">
                  <app-validvalueselect *ngIf="formattingLabel.length > 0" style="width:90%" [disabled]="false"
                                        data-cy="format-label-dropdown" validvaluename="enumFormattedLabel"
                                        [showNoneOption]="false"
                                        [dataSource]="formattingLabel"
                                        (selectedValueChange)="changeFormattedLabel($event)"
                                        [(selectedValue)]="selectedEnumFormattedLabelID"
                                        vvplaceholder="Label For"></app-validvalueselect>

                </div>
              </div>
              <tdo-table 
                [isDragAndDrop]="true" (rowsReordered)="onLabelsReordered()"
                #formattedLabelsTable [isSearchable]="false"
                [isAddButtonEnabled]="true" (addClicked)="createNewLabel()"
                cypressControlAddButtonIdentifier="buttonNewService"
                [dataSource]="filteredLabelTokenList"
                (rowSelected)="onFormattedLabelSelected($event)"
                isAutoSelectFirstItem="true"
                data-cy="format-label-tokens-table">    
                <tdo-table-column displayName="Order" propertyName="TokenOrder" [rowTemplate]="order" data-cy="format-label-order-column">
                  <ng-template #order let-row style="width: 10%">
                    <div data-cy="format-label-order-value-{{row.index}}">{{row.model.TokenOrder}}</div>
                  </ng-template>
                </tdo-table-column>            
                <tdo-table-column displayName="Prefix" propertyName="Prefix" [rowTemplate]="Prefix" style="width: 20%" data-cy="format-label-prefix-column">
                  <ng-template #Prefix let-row style="width: 20%">
                    <div style="display: flex; width: 100%; margin-bottom: 15px" data-cy="format-label-prefix-container-{{row.index}}">
                      <input [value]="row.model.Prefix" #focusOtherService
                             (focusout)="this.selectedFormattedLabelToken.Prefix = $event.target.value; this.saveFormattedLabelToken(row, selectedFormattedLabelToken, 'Prefix');"
                             style="border: unset;border-bottom: 1px solid #f1f1f1;flex: 1; background-color: unset;"
                             data-cy="format-label-prefix-input-{{row.index}}"/>
                    </div>
                  </ng-template>
                </tdo-table-column>
                <tdo-table-column displayName="Format Item" propertyName="TokenID" isSortable="false"
                                  [rowTemplate]="TokenID" style="width: 30%" data-cy="format-label-format-item-column">
                  <ng-template #TokenID let-row style="width: 30%">
                    <mat-form-field class="label-select" style="width:100%" floatLabel='never' data-cy="format-label-format-item-field-{{row.index}}">
                      <mat-label data-cy="format-label-format-item-label-{{row.index}}"></mat-label>
                      <mat-select data-cy="format-label-format-item-select-{{row.index}}"
                                  [(value)]="row.model.TokenID"
                                  (selectionChange)="this.selectedFormattedLabelToken.TokenID = $event.value; this.saveFormattedLabelToken(row, selectedFormattedLabelToken, 'enumFormattedLabel');">
                        <mat-option *ngFor="let method of this.LetterTokensList; let i = index"
                                    [value]="method.TokenID"
                                    data-cy="format-label-format-item-option-{{row.index}}-{{i}}">
                          {{ method.Description }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </tdo-table-column>
                <tdo-table-column displayName="Sufix" propertyName="Sufix" [rowTemplate]="Sufix" style="width: 20%" data-cy="format-label-suffix-column">
                  <ng-template #Sufix let-row style="width: 20%">
                    <div style="display: flex; width: 100%; margin-bottom: 15px" data-cy="format-label-suffix-container-{{row.index}}">
                      <input [value]="row.model.Sufix" #focusSufix
                             (focusout)="this.selectedFormattedLabelToken.Sufix = $event.target.value; this.saveFormattedLabelToken(row, selectedFormattedLabelToken, 'Sufix');"
                             style="border: unset;border-bottom: 1px solid #f1f1f1;flex: 1; background-color: unset;"
                             data-cy="format-label-suffix-input-{{row.index}}"/>
                    </div>
                  </ng-template>
                </tdo-table-column>
                <tdo-table-column displayName="<br/>" propertyName="isEndOfLine" [rowTemplate]="isEndOfLine" style="width: 10%" data-cy="format-label-end-line-column">
                  <ng-template #isEndOfLine let-row style="width: 10%">
                    <div style="display: flex; width: 100%; margin-bottom: 25px; margin-left: 10px" data-cy="format-label-end-line-container-{{row.index}}">
                      <mat-checkbox (change)="onIsEndOfLine(row, $event)" [checked]="row.model.isEndOfLine"
                                    style="position: relative; flex: 1; height: 10px;" data-cy="format-label-end-line-checkbox-{{row.index}}"></mat-checkbox>
                    </div>
                  </ng-template>
                </tdo-table-column>
                <tdo-table-column displayName="" propertyName="xauditDeleted" [isSortable]="false" style="width: 10%"
                                  [rowTemplate]="actions" data-cy="format-label-actions-column">
                  <ng-template #actions let-row style="width: 10%">
                    <div [matTooltip]="'Delete row ?'"
                         style="max-width: 10%; margin-bottom: 6px; cursor: pointer; color: var(--tdo-secondary); text-align: right;"
                         (click)="onDeleteOtherService(row, $event)"
                         data-cy="format-label-delete-button-{{row.index}}">
                      <mat-icon>delete_forever</mat-icon>
                    </div>
                  </ng-template>
                </tdo-table-column>
              </tdo-table>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

